import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=3f2656e9&scoped=true&"
import script from "./Edit.vue?vue&type=script&lang=js&"
export * from "./Edit.vue?vue&type=script&lang=js&"
import style0 from "./Edit.vue?vue&type=style&index=0&id=3f2656e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2656e9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oh/Projects/php_was2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f2656e9')) {
      api.createRecord('3f2656e9', component.options)
    } else {
      api.reload('3f2656e9', component.options)
    }
    module.hot.accept("./Edit.vue?vue&type=template&id=3f2656e9&scoped=true&", function () {
      api.rerender('3f2656e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Product/Edit.vue"
export default component.exports